import { ProgressController } from './progress.controller';
import template from './progress.html';

export const progressComponent = {
  name: 'progressComponent',
  restrict: 'E',
  template,
  controller: ProgressController,
  controllerAs: 'vm',
  bindings: {
    routes: '<',
    activeRoutes: '<',
    ticket: '<',
    daysLeft: '@',
    deadline: '@',
    navigate: '&'
  }
};
